import React, { useState } from "react";
import styled from "styled-components";
import { ButtonPrimary } from "ui/base/Button/ButtonStyled";
import { defaultThemeColors, fonts, mediaSizes } from "ui/theme";
import { Modal } from "ui/base/modal/Modal";
import { ClassInfoCard } from "./ClassInfoCard";
import { ClassDateCard } from "../../dateCard/ClassDateCard";

export const ClassModal = ({ classData }) => {
    const [show, setShow] = useState(false);

    const toggleInstructionsModal = () => {
        setShow((prev) => !prev);
    };

    const class_type = classData?.class_type
        ? classData?.class_type.toUpperCase()
        : "";

    return (
        <>
            <ShowMoreButton onClick={toggleInstructionsModal}>
                show more
            </ShowMoreButton>
            <Modal show={show} handleClose={() => setShow(false)} maxWidth={700}>
                <ModalBody>
                    <LeftPart>
                        <ClassInfoCard classInfo={classData} />
                    </LeftPart>
                    <RightPart>
                        <ButtonPrimary
                            variant={
                                class_type === "PRIVATE" ? "primary_fade_small" : "destructive_fade_small"
                            }
                            style={{
                                pointerEvents: "none",
                                width: 'fit-content',
                                height: 'fit-content'
                            }}
                        >
                            {class_type}
                        </ButtonPrimary>
                        <ClassDateCard date={classData.date} />
                        <DetailCol>
                            <Label>Class instructions</Label>
                            <Instructions>{classData?.class_instruction}</Instructions>
                        </DetailCol>
                    </RightPart>
                </ModalBody>
            </Modal>
        </>
    );
};

const ShowMoreButton = styled.button`
    background: none;
    border: none;
    color: ${defaultThemeColors.blue};
    cursor: pointer;
    font-family: var(--font-secondary);
    font-size: ${fonts.sizes.small};
    font-weight: 600;
    display: flex;
    align-self: flex-start;
    text-decoration: underline;
    text-decoration-style: solid;
    text-underline-offset: 2px;
    text-decoration-thickness: 0;
`;

const ModalBody = styled.div`
    display: flex;
    padding-block: 1rem;
    padding-inline: 1.5rem;
    gap: 2rem;
    flex-direction: column;
    @media (width >= ${mediaSizes.md}) {
        flex-direction: row;
    }
`;

const LeftPart = styled.div`
    width: 100%;
    @media (width >= ${mediaSizes.md}) {
        width: 40%;
    }

    /* & > img {
        object-fit: cover;
        max-width: 300px;
        width: 100%;
        aspect-ratio: 28 / 17;
        border-radius: 5px;
        border-width: 1px;
        border-style: solid;
        border-color: ${defaultThemeColors.lightBlue};
    } */
`;

const RightPart = styled.div`
    width: 100%;
    @media (width >= ${mediaSizes.md}) {
        width: 70%;
    }
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const DetailCol = styled.div`
    display: grid;
    gap: 0.3rem;
`;

const Label = styled.span`
    color: ${defaultThemeColors.placeholder};
    font-size: ${fonts.sizes.small};
    font-weight: 500;
    white-space: nowrap;
    text-transform: capitalize;
`;

const Instructions = styled.div`
    color: ${defaultThemeColors.txt};
    font-size: ${fonts.sizes.small};
    margin-top: 0.5rem;
    font-weight: 400;
    line-height: 155%;
    max-height: 13.6rem;
    letter-spacing: 0;
    word-break: break-word;
    overflow-wrap: break-word;
    overflow: auto;
`;
